import { mapGetters } from 'vuex'
import { aggregateMixins } from '@/Mixins/Aggregate'
// import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'

/*
 * Helper apps to load signatures without using the store
 */
export const signatureMixins = {
  data () {
    return {
      signatureEndpoint: 'signatures'
    }
  },

  mixins: [
    aggregateMixins
  ],

  computed: {
    // instanceUrl: this.$store.getters.getActiveInstance.url,
    // headers: getHeaders(this.$store.getters.getToken),
    ...mapGetters({
      getVendorById: 'getVendorById'
    })
  },

  methods: {
    /*
     * Post to an endpoint, options should be an object of additional parameters
     */
    async saveSignature (signatureObject) {
      // Add addt'l options if any
      const endpoint = this.signatureEndpoint + (signatureObject.id ? '/' + signatureObject.id : '')
      const response = await this.updateData(endpoint, signatureObject)
      console.log(response)
      /*
        .then(response => {
          if (response) {
            console.log('Updated' + response)
            return response
          } else {
            return false
          }
        })
        .catch(error => {
          console.log(error)
          return error
        })
      */
    },

    /*
     * Get a single page, options should be an object of additional parameters
     */
    async getSignature (userId) {
      if (!userId) return null

      const response = await this.getPage(this.signatureEndpoint, { user: userId })
      if (response && response.body && response.body.results) return response.body.results[0]
      else return null
      /*
        .then(response => {
          if (response) {
            console.log('Loaded ' + response)
            return response
          } else {
            return false
          }
        })
        .catch(error => {
          console.log(error)
          return error
        })
      */
    }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/Signatures.js